import { actions } from 'redux/reducers';
import { useDispatch } from "react-redux";
import { SentimentType }  from "types/sentiment";
import { locale, Moment } from 'moment';
import moment from 'moment';
import { useState, useEffect, useCallback } from 'react'; 
import './heatmap.scss';
import api from 'api';

function Heatmap ({
    sentiment,
    loading,
    dateFrom,
    dateTo,
    projectId,
    streamIds,
    subfolder
} : {
    sentiment: SentimentType[],
    loading: boolean,
    dateFrom: Moment,
    dateTo: Moment,
    projectId: number,
    streamIds: number[],
    subfolder: number
}){
    const dispatch = useDispatch();
    const hours = ['12a', '1a', '2a', '3a', '4a', '5a', '6a', '7a', '8a', '9a', '10a', '11a', '12p', '1p', '2p', '3p', '4p', '5p', '6p', '7p', '8p', '9p', '10p', '11p'];
    const [dates, setDates] = useState<Moment[]>([]);
    const [data, setData] = useState<any>();

    const getHeatmap = useCallback(() => {
        api.heatmap.getAllSentiment(subfolder ? subfolder : projectId, dateFrom, dateTo, streamIds).then(heatmapData => {
            setData(heatmapData.Data);
        });
    }, [dateFrom, dateTo, streamIds, projectId, subfolder]);

        const onClick = async (i: Moment) => {
        var clips = sentiment.filter(x => moment(x.DatePosted).date() == moment(i).date() && moment(x.DatePosted).hours() == moment(i).hours());
      
        dispatch(actions.clipTray.set({
            open: true,
            clips: clips
        }))
    }

    useEffect(() => {
        let d = [];
        for (var i = dateFrom.clone(); i.isSameOrBefore(); i.add(1, 'd')) {
            d.push(i.clone());
            setDates(d);
        }
    }, [dateFrom, dateTo])

    useEffect(() => {
        getHeatmap();
    }, [getHeatmap])

    return (
        <div className="heatmap">
            <div className="top">
                <p>Hourly Mentions</p>
            </div>
                <div className="body">
                <div className="graph" style={{height: `${dates.length * 33 + 33}px`}}>
                    <div className="x-axis">
                        {hours.map((x: string, i: number) => <span className="x-axis-item" key={i}>{x}</span>)}
                    </div>
                    <div className="y-axis">
                        <span className="y-axis-item"></span>
                        {dates.map((x: Moment, i: number) => <span className="y-axis-item" key={i}>{x.format("ddd DD MMM")}</span>)}
                    </div>
                    <div className="heatmap-data">
                        {loading ? (<i className="fal fa-spinner fa-spin"></i>) : 
                        ( data ? data.map((x: any, i: number) => {
                            return (
                                <span 
                                    className={`block ${x.Count === 0 ? 'empty' : ''}`}
                                    key={i}
                                    style={{backgroundColor: x.Color}}
                                    onClick={() => x.Count ? onClick(x.DatePosted) : ''}
                                >
                                    {x.Count}
                                </span>
                            )
                        }) : '')
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Heatmap;